<template>
  <div class="advanced-table">
    <app-section-header
      v-if="title"
      class="advanced-table-section-header _bb1"
    >
      <template #text>
        <p>{{ title }}</p>
      </template>
      <template #actions>
        <slot name="actions"></slot>
      </template>
    </app-section-header>

    <async-loader v-if="loading" />
    <div container v-else>
      <slot></slot>
      <app-advanced-table
        :routed-data="routedData"
        :headers="headers"
        :items="items"
        :clickable="clickable"
        @cellClicked="$emit('cellClicked', $event)"
        :noDataText="noDataText"
        :custom-sort="customSort"
        :sortBy="sortBy"
        :descending="descending"
      >
        <template
          #items="{
            item,
            index,
            selected,
            expanded,
            visibleHeaders,
            getCellValue
          }"

        >
          <slot
            name="items"
            :item="item"
            :index="index"
            :selected="selected"
            :expanded="expanded"
            :visibleHeaders="visibleHeaders"
            :getCellValue="getCellValue"
          >
            <tr
              tabindex="0"
            >
              <td
                tabindex="0"
                v-for="(header, index) in visibleHeaders"
                v-if="!header.alwaysVisible && getCellValue(item, header) !== undefined"
                :key="index"
                @keyup.enter="$emit('cellClicked', item)"
                @click="$emit('cellClicked', item)"
              >
                {{ getCellValue(item, header) }}
              </td>
              <td v-if="tableActionContent" tabindex="0">
                <slot name="tableActions" :item="item"> </slot>
              </td>
            </tr>
          </slot>
        </template>
      </app-advanced-table>
    </div>
  </div>
</template>

<script>
  import AppSectionHeader from '@organisms/SectionHeader.vue'
  import AppAdvancedTable from '@organisms/AdvancedTable.vue'
  import AsyncLoader from '@molecules/AsyncLoader'

  export default {
    components: {
      AppSectionHeader,
      AppAdvancedTable,
      AsyncLoader
    },
    props: {
      sortBy: String,
      customSort: Function,
      routedData: {
        type: Boolean,
        default: false
      },
      descending: Boolean,
      headers: Array,
      items: Array,
      title: String,
      clickable: Boolean,
      loading: {
        type: Boolean,
        default: false
      },
      noDataText: {
        type: String,
        default: 'No data available'
      }
    },
    computed: {
      tableActionContent() {
        return (
          !!this.$slots['tableActions'] || !!this.$scopedSlots['tableActions']
        )
      }
    },
    methods: {}
  }
</script>
